import {CartContext} from "../../../lib/CartProvider";
import {UserContext} from "../../../lib/UserProvider";
import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../../lib/AppContext";
import {
  checkout, checkoutTerms, checkoutTip,
  getCartFull, getCartInvoice, getCartInvoiceGroup, getCartLight,
  getCustomerCartFamilyMembers, removeAttendees, removeCartItem, saveAssignCartMembershipMembers,
  saveMyCustomerFamily,
  updateAttendees
} from "../../common/api/PortalCustomerApi";
import {Col, Modal} from "react-bootstrap";
import MDButton from "../../../components/MDButton";
import MDBadge from "../../../components/MDBadge";
import IconButton from "@mui/material/IconButton";
import CartItems from "./CartItems";
import LoginForm from "../../common/LoginForm";
import CreateAccount from "../../common/CreateAccount";
import Loading from "../../common/Loading";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import {capitalize, formatCurrency, formatDateMask, formatDouble, getBaseUrl} from "../../common/Utils";
import {useNavigate} from "react-router-dom";
import CartFamilyMembers from "./CartFamilyMembers";
import {Grid, InputAdornment} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import WaiverBody from "../waiver/WaiverBody";
import CartSuccess from "./CartSuccess";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Divider from "@mui/material/Divider";
import ForgotPasswordForm from "../../common/ForgotPasswordForm";
import ClientCartInventoryEventMemberships from "./ClientCartInventoryEventMemberships";
import StripeCheckoutPage from "../../../StripeCheckoutPage";
import SquareCheckoutPage from "../../../SquareCheckoutPage";
import {CONSTANTS} from "../../common/constants";
import CartForm from "./CartForm";
import Button from "@mui/material/Button";
import MDInput from "../../../components/MDInput";
import CartPerks from "./CartPerks";
import {MenuContext} from "../../../lib/MenuProvider";
import CartDiscountCode from "./CartDiscountCode";
import LockedAccountForm from "../form/LockedAccountForm";
import {getCustomerFamilyAll} from "../../common/api/WebApi";
import ClearIcon from "@mui/icons-material/Clear";

export default function CartFinal(props) {

  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const [menuContext, setMenuContext] = useContext(MenuContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [cartReady, setCartReady] = useState(false);
  const [checkoutFinal, setCheckoutFinal] = useState(false);
  const [addFamily, setAddFamily] = useState(false);

  const [invoice, setInvoice] = useState(null);
  useEffect(() => {
    if (cartContext?.invoice) {
      setInvoice(cartContext?.invoice);
    }
  }, [cartContext?.invoice])


  const [cartItems, setCartItems] = useState([]);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [cart, setCart] = useState();
  const [cartActive, setCartActive] = useState(false);

  const [addPaymentMethod, setAddPaymentMethod] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState({});
  const [card, setCard] = useState(null);
  const [cardInvalid, setCardInvalid] = useState(true);
  const [showLogin, setShowLogin] = useState(true);
  const navigate = useNavigate();

  const [cartMembershipMembers, setCartMembershipMembers] = useState({});
  const [cartMembershipCounts, setCartMembershipCounts] = useState({});

  const [cartMembershipSaving, setCartMembershipSaving] = useState(false);
  const [cartSize, setCartSize] = useState(localStorage.getItem('cartSize') || 0);

  const assignAssignCartMembershipMembers = (req) => {
    setCartMembershipSaving(true);
    let _req = {
      request: req
    }
    saveAssignCartMembershipMembers(_req).then((resp) => {
      setCartMembershipSaving(false);
      getCartFullFn();
    })
  }
  const validCartMembershipMembers = () => {
    let valid = true;
    for (let j in cartItems) {
      const inv = cartItems[j].inventoryItem;
      if (inv?.lockedAccount) {
        const id = cartItems[j].cartItemId;
        if (inv.accountType?.familyPass && (inv.numAdults > 0 || inv.numChildren > 0)) {
          const counts = cartMembershipCounts[id];
          if (inv.numAdults > 0) {
            valid = valid && counts?.adults > 0;
          }
          if (inv.numChildren > 0) {
            valid = valid && counts?.children > 0;
          }
        } else {
          valid = valid && cartMembershipMembers[id]?.length > 0;
        }
      }
    }
    console.log('valid ' + valid);
    return valid;
  }

  const updateCartMembershipMembers = (cartItemId, members, adults, children) => {
    setCartMembershipMembers((prev) => ({
      ...prev,
      [cartItemId]: members,
    }));
    setCartMembershipCounts((prev) => ({
      ...prev,
      [cartItemId]: {adults: adults || 0, children: children || 0},
    }));
  };

  const [giftItemOpen, setGiftItemOpen] = useState(false);

  const [waiverVisible, setWaiverVisible] = useState(false);
  const [waiver, setWaiver] = useState(null);

  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const toggleShowForgotPassword = () => {
    setShowForgotPassword(!showForgotPassword);
  }

  useEffect(() => {
    setAddPaymentMethod(false);
    setCheckingOut(false);
    setCheckoutFinal(false);
  }, [cartActive]);

  useEffect(() => {
    setAddPaymentMethod(false);
    if (cart?.checkoutDisposition === 'VIEW_CHECKOUT' && cart?.billings?.length === 0) {
      setAddPaymentMethod(true);
    }
    if (cart?.checkoutDisposition === 'REQUIRE_ATTENDEES') {
      getCartFamilyMembersFn();
    }
  }, [cart?.checkoutDisposition]);

  const [tipItems, setTipItems] = useState(cart?.tipTypes);

  useEffect(() => {
    if (cart?.tipTypes) {
      setTipItems(cart?.tipTypes);
    }
    setTipItem(null);
    setTipWarn(null);
  }, [cart?.tipTypes]);

  const [calculatedTipAmount, setCalculatedTipAmount] = useState(0);

  const [tipWarn, setTipWarn] = useState(null);
  const [tipItem, setTipItem] = useState(null);

  const setCustomTip = (amount) => {
    let _tipItem = {...tipItem};
    _tipItem.customTipAmount = amount;
    setTipItem(_tipItem);
  }

  const isTipItemSelected = (id) => {
    return tipItem?.id === id;
  }

  const getCartFamilyMembersFn = async () => {
    getCustomerCartFamilyMembers().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _members = [];
        for (let j in result) {
          if (result[j]?.familyMemberType?.id === 1) {
            _members.push(result[j]);
          }
        }
        setFamilyMembers(_members);
      }
    });
  }

  const familyMemberFn = async (data) => {
    setCartReady(false);
    removeAttendees(data).then((resp) => {
      getCartFullFn();
    });
  }

  const [cartLoading, setCartLoading] = useState(false);

  const [cartItemsIndex, setCartItemsIndex] = useState(1);

  useEffect(()=>{
    getCartLight().then((resp)=>{
      setCartSize(resp?.cartSize);
      localStorage.setItem('cartSize', resp?.cartSize);
    });
  }, [cartItemsIndex])

  const getCartFullFn = async (referrer) => {
    setCartItemsIndex(cartItemsIndex + 1);
    if (cartLoading) {
      return;
    }
    if (invoice) {
      getCartInvoiceFn(invoice, referrer);
      return;
    }
    setCartContext({...cartContext, reloadCart: true})
    setCartLoading(true);
    setCartReady(false);
    getCartFull(referrer).then(result => {
      setCartLoading(false);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCart(result);
        setCartReady(true);
      }
    });
  }

  const getCartInvoiceFn = async (invoice, referrer) => {
    setCartReady(false);
    setCartContext({...cartContext, reloadCart: true});
    if (invoice.invoiceGroup) {
      getCartInvoiceGroup(invoice?.invoiceGroupGuid, referrer || null).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setCart(result);
          setCartReady(true);
        }
      });
    } else {
      getCartInvoice(invoice?.invoiceGuid).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setCart(result);
          setCartReady(true);
        }
      });
    }
  }

  useEffect(() => {
    setCartItems(cartContext?.cartItems);
  }, [cartContext?.cartItems])

  useEffect(() => {
    setCartActive(cartContext?.viewCart);
  }, [cartContext?.viewCart]);

  useEffect(() => {
    if (cartActive) {
      if (invoice) {
        getCartInvoiceFn(invoice);
      } else {
        getCartFullFn();
      }
    }
  }, [cartActive]);

  const handleClose = (refreshCart) => {
    let _cart = {...cart};
    if (_cart.checkoutDisposition === 'VIEW_WAIVER') {
      setWaiverVisible(false);
      getCartFullFn();
      return;
    }
    _cart.checkoutDisposition = 'CART_CLOSED';
    setCart({..._cart});
    setCartContext({...cartContext, invoice: null, viewCart: false, reloadCart: refreshCart});
    setCartActive(false);
  };

  const updateCartAttendees = async () => {
    updateAttendees(cart).then(result => {
      if (result.disposition) {
        let _cart = {...cart};
        _cart.checkoutDisposition = result.disposition;
        _cart.availableAccounts = result.availableAccounts;
        setCart(_cart);
      } else {
        setCartContext({...cartContext, reloadCart: true});
        getCartFullFn();
      }
    });
  }

  const [checkingOut, setCheckingOut] = useState(false);
  const [checkedOut, setCheckedOut] = useState(false);

  const [error, setError] = useState(null);

  const checkoutFn = async () => {

    setCheckingOut(true);

    const resp = await checkout(cart);

    if (resp) {
      if (resp.error) {
        setError(resp.message);
        let _cart = {...cart};
        _cart.checkoutDisposition = 'CART_ERROR';
        _cart.error = resp?.message;
        setCart(_cart);
        return;
      }
      let _cart = {...cart};
      _cart.checkoutDisposition = 'CHECKOUT_SUCCESS';
      _cart.paymentId = resp?.paymentId;

      setCart(_cart);
    }
  }

  const continueToCheckoutFinal = async () => {

    if (tipItem && tipItem?.id) {
      let _cart = {...cart};
      _cart.tipItem = {...tipItem};
      const resp = await checkoutTip(_cart);

      if (resp) {
        let _cart = {...cart};
        _cart.purchaseGroupId = resp.purchaseGroupId;
        setCart({..._cart});
      }

    }

    if (cart?.formRequired) {
      let _cart = {...cart};
      _cart.checkoutDisposition = 'EVENT_FORM';
      setCart(_cart);
    } else {
      setCheckoutFinal(true);
    }
  }

  const continueToCheckout = () => {
    getCartFullFn(cart?.checkoutDisposition === 'VIEW_CART' ? 'VIEW_CHECKOUT' : cart?.checkoutDisposition);
  }

  const viewCart = () => {
    setCartContext({...cartContext, viewCart: true});
  }

  const handleLogin = (obj) => {
    continueToCheckout();
    setMenuContext({...menuContext, refreshContext: true})
  }

  const updatePaymentMethod = (item) => {
    setAddPaymentMethod(false);
    let _cart = {...cart};
    _cart.paymentMethod = item;
  };
  const addPaymentMethodFn = () => {
    setCard(null);
    setAddPaymentMethod(true);
  };

  const updateGiftCardItem = (item) => {
    let _cart = {...cart};
    _cart?.giftCards.forEach((_item) => {
      if (_item.guid === item.guid) {
        _item.applyValue = item.applyValue;
      }
    })
    setCart({..._cart});
  }

  const handleCardChange = (card) => {
    if (!card) {
      return;
    }
    if (!cart) {
      return;
    }
    setCard(card);
    setCardInvalid(!card?.card?.isValid);

    let _paymentMethod = {...card};
    let _cart = {...cart};
    _cart.paymentMethod = _paymentMethod;
    setCart(_cart);
  };

  const [cartRenderIdx, setCartRenderIdx] = useState(1);
  const [familyMemberRenderIdx, setFamilyMemberRenderIdx] = useState(1);

  const cartSuccessCallback = (action) => {
    if (action === 'success') {
      let _c = {...cart};
      _c.checkoutDisposition = 'CHECKOUT_SUCCESS_FINAL';
      setCart(_c);
      let _u = {...userContext};
      _u.reloadEvents = true;
      if (cart?.invoiceCheckout) {
        _u.reloadInvoices = true;
      }
      setUserContext({..._u, refreshIdentity: true});
    }
  }
  const cartCallback = (data) => {
    setCartRenderIdx(cartRenderIdx + 1);
    setCart(data);
    if (data.updateCartAttendees) {
      updateCartAttendees();
    }
  }

  const [familyMemberForm, setFamilyMemberForm] = useState();

  const saveChildMember = () => {
    saveMyCustomerFamily(familyMemberForm).then(r => {
      getCartFullFn();
    });
  }

  const familyMemberCallback = (form) => {
    setFamilyMemberForm(form);
    setFamilyMemberRenderIdx(familyMemberRenderIdx + 1);
  }


  const checkoutDisabled = () => {

    if (tipItem?.customEnabled && !tipItem?.customTipAmount) {
      return true;
    }

    let validTerms = true;
    if (cart?.cartTerms == null || cart?.cartTerms.length <= 0) {
      return false;
    }

    for (let j in cart?.cartTerms) {
      let _term = cart?.cartTerms[j];
      validTerms = validTerms && isAgreedTerms(_term);
    }

    if (validTerms) {
      return false;
    }

    return true;
  }

  const [termsAgreed, setTermsAgreed] = useState([]);

  const recalculateCart = () => {
    let _ref = cart?.applyGiftCard ? 'REMOVE_GIFT_CARD' : 'APPLY_GIFT_CARD';
    getCartFullFn(_ref);
  }

  const isAgreedTerms = (item) => {
    return termsAgreed.indexOf(item.guid) > -1;
  }

  const handleStoreAgreeWaiver = (item) => {
    if (!cart?.cartTerms || cart?.cartTerms?.length === 0) {
      return;
    }

    let cartTerms = [...cart?.cartTerms];

    const idx = cartTerms.findIndex(termItem => termItem.guid === item.guid);
    // If found, splice it out
    if (idx !== -1 && Array.isArray(cartTerms)) {
      cartTerms.splice(idx, 1);
    }
    let _c = {...cart};
    _c.cartTerms = cartTerms;
    setCart(_c);
    let _termsAgreed = [...termsAgreed];
    let _item = _termsAgreed.indexOf(item.guid);
    if (_item <= -1) {
      _termsAgreed.push(item.guid);
      setTermsAgreed(_termsAgreed);
    }
  }

  useEffect(() => {
    if (termsAgreed?.length === 0) {
      return;
    }
    let moreTerms = false;
    for (let k in cart?.cartTerms) {
      let w = cart?.cartTerms[k];
      if (!isAgreedTerms(w)) {
        let _w = {...w};
        setWaiver(_w);
        moreTerms = true;
        return;
      }
    }
    if (!moreTerms) {
      let _cart = {...cart};
      _cart.checkoutDisposition = 'VIEW_CHECKOUT'
      setCart(_cart);
      getCartFullFn();
    }
  }, [termsAgreed]);

  const hasPendingWaivers = () => {
    return cart?.cartTerms?.filter((term) => !isAgreedTerms(term))?.length > 0;
  }

  const hasCartTerms = () => {
    return cart?.cartTerms && cart?.cartTerms?.length > 0;
  }

  const dispositionHelp = (disposition) => {
    let helpText = '';
    if (disposition === 'CART_API_ERROR') {
      helpText = ' - An Unexpected Error Occurred';
    }
    if (disposition === 'CART_ERROR') {
      helpText = ' - An Error Occurred';
    }
    if (disposition === 'MANAGE_FAMILY_MEMBERS') {
      helpText = ' - Add Family Member';
    }
    if (disposition === 'REQUIRE_ATTENDEES') {
      helpText = ' - Attendees Required';
    }
    if (disposition === 'VIEW_CHECKOUT') {
      helpText = ' - Checkout';
    }
    if (disposition === 'CHALLENGE_ACCOUNT') {
      helpText = ' - Please Sign In';
    }
    if (disposition === 'CHECKOUT_VALID') {
      helpText = ' - Complete Purchase';
    }
    if (disposition === 'CHECKOUT_VALID') {
      helpText = ' - Complete Purchase';
    }
    if (disposition === 'GIFT_CARD_PURCHASE') {
      helpText = ' - Complete Purchase';
    }
    if (disposition === 'MEMBERSHIP_REQUIRED') {
      helpText = ' - Membership Required';
    }
    if (disposition === 'EVENT_FORM') {
      helpText = ' - Please Complete Event Form';
    }
    if (disposition === 'LOCKED_MEMBERSHIP_ASSIGN_FAMILY') {
      helpText = ' - Assign Member';
    }
    return helpText;
  }

  const [action, setAction] = useState(null);

  const handleSquareCartSuccess = (e) => {

    let _cart = {...cart};
    _cart.checkoutDisposition = 'CHECKOUT_SUCCESS';
    _cart.paymentId = e.paymentId;
    setCart(_cart);

    setAction('success')
  }

  const handleCartSuccess = async (e) => {
    let _cart = {...cart};
    _cart.checkoutDisposition = 'CHECKOUT_SUCCESS';
    _cart.paymentId = e.paymentIntent.id
    setCart(_cart);
    const resp = await checkoutTerms(cart);
  }

  const tipButtonStyle = {
    color: '#111',
    background: '#fff',
    border: 'solid 1px #000',
  };

  const selectedTipButtonStyle = {
    color: '#fff',
    background: '#000',
    border: 'solid 1px #000',
  };

  const [displayPaymentMethod, setDisplayPaymentMethod] = useState('');
  const [savingFamilyMember, setSavingFamilyMember] = useState(false);

  useEffect(() => {
    cart?.billings?.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1).map((b, idx) => {
      if (b.primaryCard) {
        setDisplayPaymentMethod(b?.guid);
      }
    })
  }, [cart?.billings?.length]);

  const doGetCustomerFamily = () => {
    getCustomerFamilyAll().then((resp) => {
      setFamilyMembers(resp);
    })
  }

  return (
    <>

        <div style={{
          height: '56px',
          width: '56px',
          paddingTop: '16px',
          paddingRight: '8px',
          background: '#fff',
          position: 'fixed',
          zIndex: 99999,
          right: '12px',
          top: '48px',
          border: 'solid 1px #ccc',
          borderRadius: '80px',
          boxShadow: ' 0 0 45px #646DAE94'
        }}>
          <IconButton
            size="small"
            disableRipple
            color="primary"
            aria-controls="notification-menu"
            aria-haspopup="true"
            variant="contained"
            onClick={() => {
              viewCart()
            }}
          >
            <MDBadge badgeContent={cartSize} color="error" size="xs" circular>
              <ShoppingCartIcon/>
            </MDBadge>
          </IconButton>
        </div>

      <Modal size={'xl'} fullscreen={true} dialogClassName={'psb-page-overlay psb-overlay-wide'} onHide={() => {
        handleClose(cart?.checkoutDisposition === 'CHECKOUT_SUCCESS_FINAL')
      }}
             show={cartActive}>
        <Modal.Header closeButton>
          <Modal.Title>{cart?.invoice ? 'Customer Invoice' : 'Customer Cart'} {dispositionHelp(cart?.checkoutDisposition)}</Modal.Title>
        </Modal.Header>

        {!cartReady &&
          <Loading/>
        }

        {cartReady && <>
          <Modal.Body className={'modal-overflow'}>
            {cart?.checkoutDisposition === 'CART_API_ERROR' && <>
              <MDTypography variant="p" className={'mt-3'} fontWeight="regular">
                {cart?.error && cart?.error || 'An error occurred.'}
              </MDTypography>

              <Grid item xs={12}>
                <MDTypography variant="p"
                              fontWeight="normal">
                  <center>
                    <br/><br/>
                    <MDButton variant="gradient"
                              color="info"
                              onClick={() => {
                                setCheckingOut(false);
                                setCartContext({...cartContext, reloadCart: true});
                                getCartFullFn();
                              }}>Refresh</MDButton>
                  </center>
                </MDTypography>
              </Grid>

            </>}

            {cart?.checkoutDisposition === 'VIEW_WAIVER' && waiver &&
              <WaiverBody key={waiver} waiver={waiver} callback={(_waiver) => {
                handleStoreAgreeWaiver(_waiver);
                getCartFullFn();
              }}/>}

            {cart?.checkoutDisposition === 'EVENT_FORM' && <>
              {cart?.items?.filter(x => x?.inventoryItem?.formActive).map((item, idx) => {
                return (
                  <div key={idx}>
                    <CartForm
                      callback={(evt) => {
                        if ('cancel' === evt) {
                          let _cart = {...cart};
                          _cart.checkoutDisposition = 'VIEW_CHECKOUT'
                          setCart(_cart);
                          return;
                        } else {
                          getCartFullFn();
                        }
                      }}
                      form={item.inventoryItem.form}/>

                  </div>
                )
              })
              }
            </>}

            {(cart?.checkoutDisposition === 'CHECKOUT_SUCCESS'
                || cart?.checkoutDisposition === 'CHECKOUT_SUCCESS_FINAL') && cart?.paymentId &&
              <CartSuccess
                paymentId={cart.paymentId}
                callback={cartSuccessCallback}/>}

            {cart?.checkoutDisposition === 'ADD_FAMILY_MEMBERS' && <center style={{
              width: '80%',
              margin: '0 auto'
            }}>

              <MDTypography variant="h5" fontWeight="light">An event you are registering for requires
                attendees</MDTypography>
              <MDTypography variant="p" className={'mt-3'} fontWeight="regular">
                Please continue to add family members.
              </MDTypography>

              <div>
                <MDButton
                  className={'mt-3'}
                  color="primary"
                  onClick={() => {
                    let _cart = {...cart};
                    _cart.checkoutDisposition = 'MANAGE_FAMILY_MEMBERS'
                    setCart(_cart);
                  }}>Continue</MDButton>
              </div>

            </center>}

            {cart?.checkoutDisposition === 'MANAGE_FAMILY_MEMBERS' && <>
              <CartFamilyMembers familyMembers={familyMembers}
                                 callback={familyMemberCallback}/>
            </>}
            {cart?.checkoutDisposition === 'MEMBERSHIP_REQUIRED' && <>

              <Grid item xs={12}>
                <MDTypography variant="h5" fontWeight="light">
                  An event you are registering for requires a membership
                </MDTypography>
              </Grid>
              <Grid item xs={12}>
                <MDTypography variant="p" style={{
                  display: 'block',
                  clear: 'both'
                }} className={'mt-3'} fontWeight="regular">
                  Please add membership below.
                </MDTypography>
              </Grid>

              <Grid item xs={12}>
                <ClientCartInventoryEventMemberships
                  cartItem={cart?.flaggedItem}
                  memberships={cart?.availableAccounts}
                  handleSave={(data) => {
                    getCartFullFn();
                  }}
                />
              </Grid>


            </>}
            <Grid container>
              {cart?.checkoutDisposition === 'CART_ERROR' && <>
                <Grid item xs={12}>
                  <MDTypography variant="p"
                                fontWeight="normal">
                    <center>
                      {cart?.error && cart?.error}
                      <br/>
                      Please refresh your cart.
                      <br/><br/>
                      <MDButton variant="gradient"
                                color="info"
                                onClick={() => {
                                  setCheckingOut(false);
                                  setCartContext({...cartContext, reloadCart: true});
                                  getCartFullFn();
                                }}>Refresh</MDButton>
                    </center>
                  </MDTypography>
                </Grid>
              </>}

              {cart?.checkoutDisposition === 'LOCKED_MEMBERSHIP_ASSIGN_FAMILY' && <>
                {cart?.items?.filter((item) => item?.inventoryItem?.lockedAccount).map((item, idx) => {
                  return (
                    <Grid item xs={12} key={idx}>
                      <Grid container>
                        <Grid item xs={11}>
                          <LockedAccountForm inventory={item?.inventoryItem}
                                             siblingQuantity={item?.quantity}
                                             addFamilyCallback={(cb) => {
                                               setAddFamily(cb);
                                             }}
                                             callback={(cb) => {
                                               updateCartMembershipMembers(item?.cartItemId, cb?.membershipMembers, cb?.numAssignedAdults, cb?.numAssignedChildren);
                                             }}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <MDButton
                            circular
                            iconOnly
                            className={'pull-right'}
                            color="primary" size={'small'}
                            onClick={(e) => {
                              removeCartItem(item).then((result) => {
                                getCartFullFn();
                                setCartItemsIndex(cartItemsIndex + 1);
                              });
                            }}>
                            <ClearIcon/>
                          </MDButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  )
                })
                }
              </>}

              {(cart?.checkoutDisposition === 'VIEW_CART'
                || cart?.checkoutDisposition === 'VIEW_INVOICE'
                || cart?.checkoutDisposition === 'REQUIRE_ATTENDEES'
                || cart?.checkoutDisposition === 'VIEW_CHECKOUT'
                || cart?.checkoutDisposition === 'CHECKOUT_VALID'
                || cart?.checkoutDisposition === 'GIFT_CARD_PURCHASE'
                || cart?.checkoutDisposition === 'QUICK_CHECKOUT') && <>
                <CartItems
                  cart={cart}
                  getCartFullFn={getCartFullFn}
                  callback={cartCallback}
                  familyMemberCallback={familyMemberFn}
                  tipItem={tipItem}
                  paymentMethod={displayPaymentMethod}
                  giftItemCallback={(open) => {
                    setGiftItemOpen(open)
                  }}
                >

                  {!checkoutFinal && <>
                    <CartPerks cart={cart} getCartFullFn={getCartFullFn}/>

                    <CartDiscountCode cart={cart} callback={() => {
                      getCartFullFn().then((resp) => {

                      })
                    }}/>

                    {(cart?.amountDue > 0 || (cart?.amountDue === 0 && 'GIFT_CARD_PURCHASE' === cart.checkoutDisposition)) && cart?.giftCardBalance > 0 &&
                      <div className={'psb-bordered my-2'} style={{
                        background: '#f6f1f1'
                      }}>
                        <h6>
                          You have a gift card balance of {formatCurrency(cart?.giftCardBalance)}
                        </h6>
                        <label htmlFor={'applyGiftCard'}><Checkbox
                          checked={cart?.applyGiftCard}
                          name={'applyGiftCard'}
                          id={'applyGiftCard'}
                          onChange={() => {
                            recalculateCart();
                          }}
                        />&nbsp;Yes, apply gift card to purchase
                        </label>
                      </div>
                    }
                  </>
                  }

                  {!checkoutFinal && hasPendingWaivers() && <>
                    <div style={{
                      display: 'block',
                      width: '100%',
                    }}>
                      <MDTypography variant="p"
                                    fontWeight="light">
                        One or more items in your cart requires a waiver prior to purchase.
                      </MDTypography>
                    </div>

                    {hasPendingWaivers() && <>
                      <Grid container justifyContent={'flex-start'}>
                        <Grid item xs={12} sm={12}>
                          <MDBox mt={2}>
                            <>
                              <MDButton
                                style={{
                                  float: 'right'
                                }}
                                variant="gradient"
                                color="info"
                                onClick={(e) => {
                                  e.preventDefault();
                                  let _tmpWaivers = cart?.cartTerms?.filter((term) => !isAgreedTerms(term));
                                  let _tmpWaiver = _tmpWaivers[0];
                                  setWaiver(_tmpWaiver);
                                  let _c = {...cart};
                                  _c.checkoutDisposition = 'VIEW_WAIVER';
                                  setCart(_c);
                                }}>
                                Continue to Waivers
                              </MDButton>
                            </>
                          </MDBox>
                        </Grid>
                      </Grid>

                    </>}

                  </>}

                  {(cart?.checkoutDisposition === 'VIEW_CHECKOUT' ||
                    cart?.checkoutDisposition === 'VIEW_INVOICE' ||
                    cart?.checkoutDisposition === 'CHECKOUT_VALID') && <>
                    {!checkoutFinal && <>

                      {cart.tippingEnabled && tipItems?.length > 0 && !hasPendingWaivers() && <Grid container>
                        <Grid item xs={12}>
                          <h5>Add Tip</h5>
                        </Grid>
                        <Grid item xs={12}>
                          <div variant="outlined" aria-label="Basic button group">
                            {tipItems?.sort((a, b) => a.sortOrder - b.sortOrder).map((item, idx) => {
                              return (
                                <Button key={idx}
                                        variant="outlined"
                                        onClick={(e) => {
                                          setTipItem(item);
                                          setCalculatedTipAmount(cart.tippableItemsTotal * (item.tipPercentage * .01))
                                        }}
                                        style={isTipItemSelected(item.id) ? selectedTipButtonStyle : tipButtonStyle}>
                                  <span style={{
                                    fontWeight: 'bold',
                                    display: 'block',
                                    width: '100%',
                                    textAlign: 'center'
                                  }}>{item.tipPercentage}% <br/> {formatCurrency(item.tipAmount)}</span>
                                </Button>
                              )
                            })
                            }
                            <Button
                              variant="outlined"
                              onClick={(e) => {
                                setTipItem({
                                  id: -1,
                                  customEnabled: true
                                });
                                setCalculatedTipAmount(0)
                              }}
                              style={isTipItemSelected(-1) ? selectedTipButtonStyle : tipButtonStyle}
                            >
                              <span style={{
                                fontWeight: 'bold',
                                display: 'block',
                                width: '100%',
                                textAlign: 'center',
                                padding: '8px 0 9px 0'
                              }}>Other</span>
                            </Button>
                            <Button variant="outlined"
                                    onClick={(e) => {
                                      setTipItem({
                                        id: -10,
                                        customEnabled: false
                                      });
                                      setCalculatedTipAmount(0)
                                    }}
                                    style={isTipItemSelected(-10) ? selectedTipButtonStyle : tipButtonStyle}
                            ><span style={{
                              fontWeight: 'bold',
                              display: 'block',
                              width: '100%',
                              textAlign: 'center',
                              padding: '8px 0 9px 0'
                            }}>None
                            </span></Button>
                            {tipItem?.customEnabled && <>
                              <span style={{
                                display: 'block', margin: '4px',
                              }}>
                                <small>Enter tip amount: </small><br/>
                                <MDInput type={'text'}
                                         required={tipItem?.customEnabled}
                                         disabled={!tipItem || !tipItem?.customEnabled}
                                         placeholder={'0.00'}
                                         onChange={(e) => {
                                           let _amount = e.target.value;
                                           _amount = e.target.value.replace(/[^0-9.]/g, '');
                                           let cents = _amount.split('.');
                                           if (cents[1]?.length > 2) {
                                             _amount = parseFloat(_amount).toFixed(2);
                                           }
                                           setTipWarn(null);
                                           if (_amount > parseFloat(cart?.amountDue)) {
                                             _amount = parseFloat(cart?.amountDue);
                                             setTipWarn('Custom tip amount exceeds allowed value')
                                           }
                                           e.target.value = _amount;
                                           setCustomTip(_amount);
                                         }}
                                         InputProps={{
                                           startAdornment: <InputAdornment position="start">
                                             <b>$</b>
                                           </InputAdornment>,
                                         }}/>
                              </span>
                              {tipWarn && <small>{tipWarn}</small>}
                            </>
                            }

                          </div>
                        </Grid>

                      </Grid>
                      }
                      {!hasPendingWaivers() &&
                        <Grid container justifyContent={'flex-start'}>
                          <Grid item xs={12} sm={12}>
                            <MDBox mt={2}>
                              <>
                                <MDButton
                                  style={{
                                    float: 'right'
                                  }}
                                  disabled={checkoutDisabled()}
                                  variant="gradient"
                                  color="info"
                                  onClick={() => {
                                    continueToCheckoutFinal()
                                  }}>
                                  Continue to Payment
                                </MDButton>
                              </>
                            </MDBox>
                          </Grid>
                        </Grid>
                      }

                    </>
                    }
                  </>
                  }

                  {checkoutFinal && cart.amountDue > 0 &&

                    <Grid item xs={12} sm={12}>

                      <MDBox mt={2}>

                        <h6>
                          Payment Method
                        </h6>

                        <Grid container spacing={1}>
                          {cart && cart?.billings?.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                            .map((item, index) => {
                              return (
                                <Grid item xs={12} sm={6} key={index}>
                                  <MDButton color={"secondary"} style={{
                                    width: '100%',
                                    padding: '12px 0'
                                  }} size={'small'}
                                            variant={displayPaymentMethod === item?.guid ? 'contained' : 'outlined'}
                                            onClick={() => {
                                              updatePaymentMethod(item);
                                              setDisplayPaymentMethod(item?.guid);
                                            }}>{capitalize(item.cardType)} ending in
                                    **** {item.cardNumber} ({item.ccExpy})</MDButton>
                                </Grid>
                              )
                            })}


                          <Grid item xs={12} sm={6}>
                            <MDButton color={"secondary"} style={{
                              width: '100%',
                              padding: '12px 0'
                            }} size={'small'} variant={displayPaymentMethod === 'new' ? 'contained' : 'outlined'}
                                      onClick={() => {
                                        addPaymentMethodFn(true);
                                        setDisplayPaymentMethod('new');
                                      }}>New Payment Method</MDButton>
                          </Grid>

                        </Grid>


                        {addPaymentMethod &&
                          <>
                            {cart?.paymentGatewayId === CONSTANTS.EXT_APPLICATION.SQUARE && <>
                              <SquareCheckoutPage
                                handleSuccess={(e) => {
                                  handleSquareCartSuccess(e)
                                }}
                                handleError={(e) => {
                                  let _cart = {...cart};
                                  _cart.checkoutDisposition = 'CART_API_ERROR';
                                  _cart.error = e.response?.data?.message || e.message;
                                  setCart(_cart);
                                }}
                                cart={cart}/>
                            </>}
                            {cart?.paymentGatewayId === CONSTANTS.EXT_APPLICATION.STRIPE && <>
                              <StripeCheckoutPage
                                handleSuccess={(e) => {
                                  handleCartSuccess(e)
                                }}
                                handleError={(e) => {
                                  let _cart = {...cart};
                                  _cart.checkoutDisposition = 'CART_API_ERROR';
                                  _cart.error = e.message;
                                  setCart(_cart);
                                }}
                                cart={cart}/>
                            </>
                            }
                          </>
                        }
                      </MDBox>
                    </Grid>
                  }
                </CartItems>
              </>
              }
              {cart?.checkoutDisposition === 'CART_EMPTY' && <>
                <Col xs={12}>
                  <h5>Your cart is empty.&nbsp;
                    <span
                      className="link cursor-pointer text-info text-decoration-underline"
                      onClick={() => {
                        handleClose(false);
                      }}>
                Continue shopping?</span>
                  </h5>
                </Col>
              </>}

              {cart?.checkoutDisposition === 'CHALLENGE_ACCOUNT' && <>
                {!showLogin && <Grid item xs={12}>
                  <CreateAccount
                    handleCancel={() => {
                      setShowLogin(true);
                    }}
                    handleSave={() => {
                      continueToCheckout();
                    }}
                  />
                </Grid>
                }

                {showLogin && <>
                  {showForgotPassword && <ForgotPasswordForm
                    callback={(e) => {
                      setShowForgotPassword(false);
                    }}
                    handleSuccess={(e) => {
                      continueToCheckout()
                    }}
                  />}
                  {!showForgotPassword && <LoginForm
                    showCreateAccount={() => {
                      setShowLogin(false);
                    }}
                    toggleShowForgotPassword={() => {
                      toggleShowForgotPassword()
                    }}
                    handleLogin={handleLogin}/>
                  }
                </>
                }
              </>
              }

            </Grid>
          </Modal.Body>
          {cart?.checkoutDisposition === 'CHECKOUT_SUCCESS_FINAL' && <>
            <Modal.Footer>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  handleClose(true)
                }}>
                Close
              </MDButton>
            </Modal.Footer>
          </>}
          {!addPaymentMethod && <>
            {cart?.checkoutDisposition === 'VIEW_CART' && <>
              <Modal.Footer>
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={() => {
                    continueToCheckout()
                  }}>
                  Continue to Checkout
                </MDButton>
              </Modal.Footer>
            </>
            }
            {
              (checkoutFinal && cart?.checkoutDisposition === 'CHECKOUT_VALID' ||
                cart?.checkoutDisposition === 'QUICK_CHECKOUT' ||
                cart?.checkoutDisposition === 'GIFT_CARD_PURCHASE') && <>
                <Modal.Footer>
                  <MDButton variant="gradient"
                            color="info"
                            disabled={checkoutDisabled() || checkingOut}
                            onClick={() => {
                              checkoutFn();
                            }}>Complete Purchase
                  </MDButton>
                </Modal.Footer>
              </>
            }
            {cart?.checkoutDisposition === 'MANAGE_FAMILY_MEMBERS' && <>
              <Modal.Footer>
                {familyMemberRenderIdx &&
                  <>
                    {familyMembers?.length > 0 &&
                      <span style={{
                        float: 'left'
                      }}>
                      <MDButton color="primary"
                                onClick={() => {
                                  getCartFullFn();
                                }}>Back to Cart
                    </MDButton>&nbsp;
                    </span>
                    }
                    <MDButton color="info"
                              disabled={!familyMemberForm?.valid}
                              onClick={saveChildMember}>Save Family Member
                    </MDButton>

                  </>
                }
              </Modal.Footer>
            </>}

            {cart?.checkoutDisposition === 'LOCKED_MEMBERSHIP_ASSIGN_FAMILY' && <>
              <Modal.Footer>
                {addFamily && <MDButton type={"submit"}
                                        form={"lockedAccountMemberForm"}
                                        variant="gradient"
                                        color="info"
                >{cartMembershipSaving ? 'Saving...' : 'Save'}
                </MDButton>
                }

                {!addFamily && cartRenderIdx && <MDButton variant="gradient"
                                                          color="info"
                                                          disabled={!validCartMembershipMembers() || cartMembershipSaving}
                                                          onClick={() => {
                                                            assignAssignCartMembershipMembers(cartMembershipMembers);
                                                          }}>{cartMembershipSaving ? 'Updating Cart...' : 'Update Cart'}
                </MDButton>}
              </Modal.Footer>
            </>
            }

            {cart?.checkoutDisposition === 'REQUIRE_ATTENDEES' && <>
              <Modal.Footer>
                {cartRenderIdx && <MDButton variant="gradient"
                                            color="info"
                                            disabled={!cart?.validCartAttendees}
                                            onClick={updateCartAttendees}>Update Cart
                </MDButton>}
              </Modal.Footer>
            </>
            }
          </>
          }
        </>
        }
        {cartReady && <>
          {cart?.checkoutDisposition === 'CHALLENGE_ACCOUNT' && !showLogin && <Modal.Footer style={{
            background: '#EFEFEF',
            justifyContent: 'center'
          }}>
            <center>
              <p>
                Already have an account?
                <br/>
                <a className={'link-underline-info cursor-pointer'} onClick={() => {
                  setShowLogin(true);
                }}>Sign In</a>
              </p>
            </center>
          </Modal.Footer>
          }

          {cart?.checkoutDisposition === 'CHALLENGE_ACCOUNT' && <>
            {showForgotPassword && <Modal.Footer style={{
              background: '#EFEFEF',
              justifyContent: 'center'
            }}>
              <Divider/>
              <MDTypography variant="p" fontWeight="light">
                <center>
                  <p>
                    <a className={'link-underline-info cursor-pointer pull-right'} onClick={() => {
                      toggleShowForgotPassword();
                    }}>Back to Sign In</a>
                  </p>
                </center>
              </MDTypography>
            </Modal.Footer>}


            {!showForgotPassword && showLogin && <Modal.Footer style={{
              background: '#EFEFEF',
              justifyContent: 'center'
            }}>
              <Divider/>
              <MDTypography variant="p" fontWeight="light">
                <center>
                  <p>
                    <a className={'link-underline-info cursor-pointer pull-right'} onClick={() => {
                      toggleShowForgotPassword();
                    }}>Forgot Password?</a>
                  </p>
                </center>
              </MDTypography>
            </Modal.Footer>}
          </>
          }
        </>
        }
      </Modal>
    </>
  )
}